import axios from 'axios';

/* this is inplace as at this time when we get an error from the
akamai system THD will send some sort page like the "Oops we are fixing it"
page. We decided that instaed we'd just render the appropriate error message
set up for whatever request is being made */
function handleAkamaiErrorResponse() {
  return Promise.reject(new Error('Oops something went wrong.'));
}

const AxiosClient = axios.create({
  withCredentials: true,
});

AxiosClient.interceptors.request.use((config) => {
  config.headers = {
    ...config.headers,
    ...(typeof window !== 'undefined' &&
      window?.THD_ACCOUNT_LIB?.TMX?.getTMXsessionId() && {
        tmxProfileId: window.THD_ACCOUNT_LIB.TMX.getTMXsessionId(),
      }),
  };
  return config;
});

const createRequestOptions = (headers) => {
  const options = {};
  if (headers) {
    options.headers = headers;
  }
  options.withCredentials = true;
  return options;
};

AxiosClient.interceptors.response.use(
  function handleSuccessfulResponse(res) {
    /* Traffic manager through akamai will interecept some responses
       and send back a 200 repsone, even though there is an error
       The most consistent field in these responses is the
       html it sends back which is the "oops we are fixing it"
       page you see from time to time. See comment on function
       for implementaiton details
    */
    if (res.headers['content-type'] === 'text/html') {
      return handleAkamaiErrorResponse();
    }
    return res;
  },
  // function handleRejectedResponse(error) {
  // if (error.response.status === 401
  //   || (error.response.status === 400 && error?.response?.data?.errors[0]?.errorCode === 'AUTH_ERR_101')
  //   || error.response.status === 403) {
  //   window.location.replace('/auth/view/signin?redirect=/military/discount');
  // }
  //   return Promise.reject(error);
  // }
);

export const getRequest = (url, headers) => {
  try {
    const response = AxiosClient.get(url, { ...createRequestOptions(headers) });
    return response;
  } catch (error) {
    return error;
  }
};

export const postRequest = (apiUrl, apiHeaders, data) => {
  try {
    const response = AxiosClient.post(apiUrl, data, { headers: apiHeaders });
    return response;
  } catch (error) {
    return error;
  }
};

export default AxiosClient;
